/**
 * Not Found Page
 *
 * Displayed when:
 * - User navigates to a route that doesn't exist
 * - User tries to access a tenant they don't have access to
 */

import { useRouter } from "expo-router";
import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { PressableScale } from "pressto";
import { Icon } from "@src/components/Icon";

export default function NotFoundScreen() {
  const router = useRouter();
  const { theme } = useUnistyles();

  const handleGoHome = () => {
    router.replace("/");
  };

  return (
    <View flex={1} bg="background" alignItems="center" justifyContent="center" px="6xl">
      <Icon
        name="errorOutline"
        size={80}
        color={theme.colors.textMuted}
        style={{ marginBottom: theme.spacing["6xl"] }}
      />

      <Text textStyle="lg/semibold" mb="md" textAlign="center">
        Page Not Found
      </Text>

      <Text textStyle="md/regular" color="textMuted" mb="8xl" textAlign="center">
        The page you&apos;re looking for doesn&apos;t exist or you don&apos;t have access to it.
      </Text>

      <PressableScale
        onPress={handleGoHome}
        style={{
          backgroundColor: theme.colors.interactive.buttons.default_background,
          paddingVertical: theme.spacing["3xl"],
          paddingHorizontal: theme.spacing["6xl"],
          borderRadius: theme.spacing.xl,
        }}
      >
        <Text textStyle="md/semibold" style={{ color: theme.colors.interactive.buttons.default_foreground }}>
          Go to Home
        </Text>
      </PressableScale>
    </View>
  );
}
